import { Modal, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as SearchSmIcon } from "components/Icons/search-sm.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { useEffect, useState } from "react";
import { SearchModal } from "./SearchList/SearchModal";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      background: "#F2F2F2",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: ({ isDrawerOpen }: { isDrawerOpen: boolean }) =>
        isDrawerOpen ? "space-between" : "center",
      padding: ({ isDrawerOpen }: { isDrawerOpen: boolean }) =>
        isDrawerOpen ? theme.spacing(2, 8) : theme.spacing(0),
      minHeight: 37,
      width: ({ isDrawerOpen }: { isDrawerOpen: boolean }) =>
        !isDrawerOpen ? "48px" : "unset",
      height: ({ isDrawerOpen }: { isDrawerOpen: boolean }) =>
        !isDrawerOpen ? "48px" : "unset",
      cursor: "pointer",
    },
    titleWrapper: {
      display: "flex",
      alignItems: "center",
      color: "#808080",

      "& svg": {
        color: "#808080",
        width: 20,
        height: 20,
        marginRight: ({ isDrawerOpen }: { isDrawerOpen: boolean }) =>
          isDrawerOpen ? theme.spacing(5) : 0,
      },
    },
    shortcut: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#F9F9F9",
      border: "1px solid #E5E5E5",
      borderRadius: "4px",
      fontWeight: 400,
      height: 21,
      width: 34,
      color: "#808080",
      fontSize: 12,
      padding: theme.spacing(0, 1),
      lineHeight: "100%",
    },
    modal: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  }),
);

interface Props {
  isDrawerOpen: boolean;
}

export const Search = ({ isDrawerOpen }: Props) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const classes = useStyles({ isDrawerOpen });
  const { message } = useMessage();

  useEffect(() => {
    const listener = (e: any) => {
      const isSpecialKey = e.ctrlKey || e.metaKey;

      if (isSpecialKey && e.code === "Slash") {
        setIsSearchOpen(!isSearchOpen);
      }
    };

    document.addEventListener("keydown", listener);

    return () => document.removeEventListener("keydown", listener);
  }, [isSearchOpen]);

  const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
  const shortcut = isMacLike ? "⌘+/" : "ctrl+/";

  return (
    <>
      <div className={classes.wrapper} onClick={() => setIsSearchOpen(true)}>
        <div className={classes.titleWrapper}>
          <SearchSmIcon />
          {isDrawerOpen && (
            <Typography fontSize={14}>{message({ id: "search" })}</Typography>
          )}
        </div>
        {isDrawerOpen && <div className={classes.shortcut}>{shortcut}</div>}
      </div>
      <Modal
        className={classes.modal}
        open={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      >
        <>
          <SearchModal closeModal={() => setIsSearchOpen(false)} />
        </>
      </Modal>
    </>
  );
};
